import Vue from 'vue';
import R from '@/resources/constants/reports-of-sickness';

const state = {
};

const getters = {
};

const actions = {
  [R.Actions.Delete.SUCCESS] () {
    Vue.toasted.success('De verzuimmelding is succesvol verwijderd.', {
      icon: 'done'
    });
  },

  [R.Actions.Recovery.Create.SUCCESS] () {
    Vue.toasted.success('Het volledig herstel van de werknemer is succesvol gemeld.', {
      icon: 'done'
    });
  },

  [R.Actions.Recovery.Update.SUCCESS] () {
    Vue.toasted.success('Het volledig herstel van de werknemer is succesvol gewijzigd.', {
      icon: 'done'
    });
  },

  [R.Actions.Recovery.Delete.SUCCESS] () {
    Vue.toasted.success('Het volledig herstel van de werknemer is succesvol verwijderd.', {
      icon: 'done'
    });
  },

  [R.Actions.Period.Create.SUCCESS] () {
    Vue.toasted.success('Wijziging in het verzuim is succesvol doorgegeven.', {
      icon: 'done'
    });
  },

  [R.Actions.Period.Delete.SUCCESS] () {
    Vue.toasted.success('De wijziging in het verzuim van de werknemer is succesvol verwijderd.', {
      icon: 'done'
    });
  },

  [R.Actions.Period.Update.SUCCESS] () {
    Vue.toasted.success('Het bewerken van de wijziging in het verzuim was succesvol.', {
      icon: 'done'
    });
  },

  [R.Actions.UwvDecision.Create.SUCCESS] () {
    Vue.toasted.success('Het doorgeven van de UWV beslissing was succesvol.', {
      icon: 'done'
    });
  },

  [R.Actions.Create.SUCCESS] () {
    Vue.toasted.success('Nieuw verzuim is succesvol aangemaakt.', {
      icon: 'done'
    });
  },

  [R.Actions.Update.SUCCESS] () {
    Vue.toasted.success('Ziekmelding is met succes gewijzigd.', {
      icon: 'done'
    });
  }
};

const mutations = {
};

export default {
  namespaced: false,
  state,
  getters,
  actions,
  mutations
};
